// Provides the main model for a page, if present.
'use strict';

var embed = require('./embedded-data');
var utils = require('./utils');

function get() {
  return utils.copyObject(embed.model || {});
}

module.exports = {
  get: get,
};
